'use client';

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type State = {
  opened: boolean;
  isOpened?: () => boolean;
  toggleOpened: () => void;
  setOpened: (value: boolean) => void;
};

export const useSidebarStore = create<State>()(
  persist(
    (set, get) => ({
      opened: false,
      isOpened: () => get().opened,
      toggleOpened: () => set((state) => ({ opened: !state.opened })),
      setOpened: (value) => set({ opened: value }),
    }),
    {
      name: 'sidebar-store',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ opened: state.opened }),
    }
  )
);
